import { Button } from 'antd';
import Colors from '@/constants/Colors';
import styled from 'styled-components';
import { css } from 'styled-components';
import { pxToVw } from '@/modules/styled/cssUnits';

const baseGameButton = css`
  height: auto;
  background-color: ${Colors.blue};
  border-radius: 5px;
  padding: 0.2em 1em;
  color: white;
  font-family: museo-sans;
  text-align: center;
  border-color: transparent;
`;

export const StyledGameButton = styled(Button)`
  &.primary {
    ${baseGameButton}
  }

  &.secondary {
    ${baseGameButton}
    background-color: white;
    color: ${Colors.blue};
    &[disabled] {
      opacity: 0.5;
    }
  }
  &.correct {
    ${baseGameButton}
    background-color: ${Colors.green};

    &[disabled] {
      opacity: 1;
      &:hover {
        ${baseGameButton}
        background-color: ${Colors.green};
      }
    }
  }
  &.incorrect {
    ${baseGameButton}
    background-color: ${Colors.red};
    &[disabled] {
      opacity: 0.5;
    }
  }
`;
